export default {"src":"/_next/static/media/icon-curiosity.750c64dc.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};